export default __webpack_public_path__ + "static/media/report.49a287b0.png";